import { render, staticRenderFns } from "./StudentWorkHistory.vue?vue&type=template&id=3d779983"
import script from "./StudentWorkHistory.vue?vue&type=script&lang=js"
export * from "./StudentWorkHistory.vue?vue&type=script&lang=js"
import style0 from "./StudentWorkHistory.vue?vue&type=style&index=0&id=3d779983&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports